module.exports = __webpack_public_path__ + "img/qrcode.51ab551a.svg";